import React, { useState, useEffect } from "react";

const AivySideBanner = () => {
  const [sparkles, setSparkles] = useState([]);

  useEffect(() => {
    const interval = setInterval(() => {
      const newSparkle = {
        id: Date.now(),
        left: Math.random() * 100 + "%",
        top: Math.random() * 100 + "%",
      };

      setSparkles((prev) => [...prev, newSparkle]);

      setTimeout(() => {
        setSparkles((prev) => prev.filter((s) => s.id !== newSparkle.id));
      }, 3000);
    }, 1500);

    return () => clearInterval(interval);
  }, []);

  const handleBannerClick = (e) => {
    window.open("https://aistudio.aivy.kr", "_blank"); 
  };

  const handleButtonClick = (e) => {
    e.stopPropagation(); // 이벤트 버블링 방지
    window.open("https://aistudio.aivy.kr", "_blank");
  };

  return (
    <div className="banner-wrapper">
      <style>{`
        .banner-wrapper {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
          position: fixed;
          left: 80px;
          top: 48%;
          transform: translateY(-50%);
          z-index: 40;
          padding: 0;
          display: none;
        }
        
        @media (min-width: 1536px) {
          .banner-wrapper {
            display: block;
          }
        }
        
        .side-banner {
          width: 160px;
          height: 550px;
          position: relative;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
          border-radius: 20px;
          overflow: hidden;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
        }
        
        .side-banner:hover {
          transform: translateX(5px);
          box-shadow: 0 15px 40px rgba(102, 126, 234, 0.4);
        }
        
        .bg-animation {
          position: absolute;
          width: 100%;
          height: 100%;
          opacity: 0.3;
        }
        
        .wave {
          position: absolute;
          width: 200%;
          height: 200%;
          background: radial-gradient(circle, rgba(255, 255, 255, 0.3) 0%, transparent 70%);
          animation: wave 8s ease-in-out infinite;
        }
        
        .wave-1 {
          top: -50%;
          left: -50%;
          animation-delay: 0s;
        }
        
        .wave-2 {
          bottom: -50%;
          right: -50%;
          animation-delay: 4s;
        }
        
        @keyframes wave {
          0%, 100% {
            transform: scale(0.8) rotate(0deg);
          }
          50% {
            transform: scale(1.2) rotate(180deg);
          }
        }
        
        .sparkle {
          position: absolute;
          width: 3px;
          height: 3px;
          background: white;
          border-radius: 50%;
          animation: sparkle 3s linear;
          pointer-events: none;
        }
        
        @keyframes sparkle {
          0% {
            opacity: 0;
            transform: translateY(0) scale(0);
          }
          50% {
            opacity: 1;
            transform: translateY(-20px) scale(1);
          }
          100% {
            opacity: 0;
            transform: translateY(-40px) scale(0);
          }
        }
        
        .content {
          position: relative;
          z-index: 10;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          padding: 30px 20px;
          text-align: center;
          color: white;
        }
        
        .logo-section {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        
        .logo-icon {
          width: 50px;
          height: 50px;
          margin-bottom: 15px;
          position: relative;
          animation: float 3s ease-in-out infinite;
        }
        
        .logo-icon svg {
          width: 100%;
          height: 100%;
          fill: rgba(255, 255, 255, 0.9);
        }
        
        @keyframes float {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }
        
        .brand-name {
          font-size: 24px;
          font-weight: 700;
          margin-bottom: 5px;
          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
        }
        
        .brand-subtitle {
          font-size: 18px;
          font-weight: 600;
          opacity: 0.95;
        }
        
        .middle-section {
          flex: 2;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 100%;
        }
        
        .feature-text {
          font-size: 16px;
          line-height: 1.6;
          font-weight: 500;
          margin: 10px 0;
          opacity: 0.9;
        }
        
        .divider {
          width: 60px;
          height: 2px;
          background: rgba(255, 255, 255, 0.5);
          margin: 20px 0;
          border-radius: 1px;
        }
        
        .cta-section {
          width: 100%;
        }
        
        .cta-button {
          display: block;
          width: 100%;
          padding: 12px 20px;
          background: rgba(255, 255, 255, 0.2);
          backdrop-filter: blur(10px);
          border: 2px solid rgba(255, 255, 255, 0.5);
          border-radius: 25px;
          color: white;
          text-decoration: none;
          font-size: 16px;
          font-weight: 600;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
          cursor: pointer;
          text-align: center;
        }
        
        .cta-button::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          width: 0;
          height: 0;
          background: rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          transform: translate(-50%, -50%);
          transition: width 0.6s, height 0.6s;
        }
        
        .cta-button:hover {
          background: rgba(255, 255, 255, 0.3);
          border-color: white;
          transform: scale(1.05);
        }
        
        .cta-button:hover::before {
          width: 150%;
          height: 150%;
        }
        
        .decoration {
          position: absolute;
          width: 100%;
          height: 100%;
          pointer-events: none;
        }
        
        .circle {
          position: absolute;
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          animation: rotate 20s linear infinite;
        }
        
        .circle-1 {
          width: 100px;
          height: 100px;
          top: 10%;
          left: -50px;
        }
        
        .circle-2 {
          width: 80px;
          height: 80px;
          bottom: 15%;
          right: -40px;
          animation-direction: reverse;
        }
        
        @keyframes rotate {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>

      <div className="side-banner" onClick={handleBannerClick}>
        {/* 애니메이션 배경 */}
        <div className="bg-animation">
          <div className="wave wave-1"></div>
          <div className="wave wave-2"></div>
        </div>

        {/* 장식 요소 */}
        <div className="decoration">
          <div className="circle circle-1"></div>
          <div className="circle circle-2"></div>
        </div>

        {/* 고정 반짝임 */}
        <div
          className="sparkle"
          style={{ top: "20%", left: "30%", animationDelay: "0s" }}
        ></div>
        <div
          className="sparkle"
          style={{ top: "50%", right: "25%", animationDelay: "1s" }}
        ></div>
        <div
          className="sparkle"
          style={{ bottom: "30%", left: "40%", animationDelay: "2s" }}
        ></div>

        {/* 동적 반짝임 */}
        {sparkles.map((sparkle) => (
          <div
            key={sparkle.id}
            className="sparkle"
            style={{
              left: sparkle.left,
              top: sparkle.top,
            }}
          />
        ))}

        {/* 메인 콘텐츠 */}
        <div className="content">
          <div className="logo-section">
            <div className="logo-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
              </svg>
            </div>
            <div className="brand-name">Aivy</div>
            <div className="brand-subtitle">AI Studio</div>
          </div>

          <div className="middle-section">
            <div className="divider"></div>
            <div className="feature-text">
              AI 자동
              <br />
              설문
            </div>
            <div className="feature-text">&</div>
            <div className="feature-text">
              분석
              <br />
              플랫폼
            </div>
            <div className="divider"></div>
          </div>

          <div className="cta-section">
            <button className="cta-button" onClick={handleButtonClick}>
              바로가기
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AivySideBanner;
